import React, { useState } from 'react';
import Tab from '@/Modules/tab';
import UserAccount from './UserAccount';
import UserInterest from './UserInterest';

const AccountManagement = () => {
  const [activeKey, setActiveKey] = useState('1');

  return(
    <Tab 
      activeKey={activeKey}
      onChange={setActiveKey}
      items={[
        {
          key: '1',
          label: 'Account',
          children: <UserAccount />
        },
        {
          key: '2',
          label: 'Account Interest',
          children: <UserInterest />
        }
        
      ]}
    />
  )
}

export default AccountManagement;
